<template>
  <b-card>
    <b-row class="position-relative">
      <b-col
        md="12"
      >
        <validation-observer ref="oldAccountOfficerRules">
          <b-form>
            <b-row>
              <b-col md="6">
                <SelectField
                  id="select-old-staff-id"
                  v-model="oldStaffSearchParams.oldStaffID"
                  :label="$t('Select Old Account Officer')"
                  :reduce="option => option.value"
                  :options="accountOfficerOptions"
                  :placeholder="$t('Select')"
                  rules="required"
                  :error-name="$t('Select Old Account Officer')"
                  item="label"
                />
              </b-col>

              <b-col md="2">
                <Button
                  :label="$t('Search')"
                  size="md"
                  class="mt-2"
                  block
                  @click="handleOldStaffIDSearch"
                />
              </b-col>
            </b-row>

          </b-form>
        </validation-observer>
        <div v-if="isOldStaff">
          <app-collapse
            class="business-items mb-4"
            type="margin"
            accordion
          >
            <app-collapse-item
              :title="$t('Account Officer Information')"
              class="card-item"
              is-visible
            >
              <b-row>
                <b-col md="4">
                  <InputField
                    id="name"
                    v-model="oldAccountOfficer.name"
                    :label="$t('Name')"
                    type="text"
                    readonly
                  />
                </b-col>
                <b-col md="4">
                  <InputField
                    id="branch-name"
                    v-model="oldAccountOfficer.branchName"
                    :label="$t('Branch Name')"
                    type="text"
                    readonly
                  />
                </b-col>
                <b-col md="4">
                  <InputField
                    id="staff-id"
                    v-model="oldAccountOfficer.staffID"
                    :label="$t('Staff ID')"
                    type="text"
                    readonly
                  />
                </b-col>
                <b-col md="4">
                  <InputField
                    id="gender"
                    v-model="oldAccountOfficer.gender"
                    :label="$t('Gender')"
                    type="text"
                    readonly
                  />
                </b-col>
                <b-col md="4">
                  <InputField
                    id="phone-number"
                    v-model="oldAccountOfficer.phoneNumber"
                    :label="$t('Phone Number')"
                    type="text"
                    readonly
                  />
                </b-col>
                <b-col md="4">
                  <InputField
                    id="supervisor"
                    v-model="oldAccountOfficer.supervisor"
                    :label="$t('Supervisor')"
                    type="text"
                    readonly
                  />
                </b-col>
                <b-col md="4">
                  <InputField
                    id="status"
                    v-model="oldAccountOfficer.status"
                    :label="$t('Status')"
                    type="text"
                    readonly
                  />
                </b-col>
                <b-col md="4">
                  <TextAreaField
                    id="address"
                    v-model="oldAccountOfficer.address"
                    rows="2"
                    :placeholder="$t('Address')"
                    :label="$t('Address')"
                    type="text"
                    readonly
                  />
                </b-col>

              </b-row>
            </app-collapse-item>
          </app-collapse>
        </div>
        <div v-if="isOldStaff">
          <validation-observer ref="newAccountOfficerRules">
            <b-form>
              <b-row>
                <b-col md="6">
                  <SelectField
                    id="select-new-staff-id"
                    v-model="newStaffSearchParams.newStaffID"
                    :label="$t('Select New Account Officer')"
                    :reduce="option => option.value"
                    :options="accountOfficerOptions"
                    :placeholder="$t('Select')"
                    rules="required"
                    :error-name="$t('Select New Account Officer')"
                    item="label"
                  />
                </b-col>

                <b-col md="2">
                  <Button
                    :label="$t('Search')"
                    size="md"
                    class="mt-2"
                    block
                    @click="handleNewStaffIDSearch"
                  />
                </b-col>
              </b-row>
            </b-form>
          </validation-observer>
        </div>
        <!-- isNewStaff -->
        <div v-if="isNewStaff">
          <app-collapse
            class="business-items mb-4"
            type="margin"
            accordion
          >
            <app-collapse-item
              :title="$t('Account Officer Information')"
              class="card-item"
              is-visible
            >
              <b-row>
                <b-col md="4">
                  <InputField
                    id="name"
                    v-model="newAccountOfficer.name"
                    :label="$t('Name')"
                    type="text"
                    readonly
                  />
                </b-col>
                <b-col md="4">
                  <InputField
                    id="branch-name"
                    v-model="newAccountOfficer.branchName"
                    :label="$t('Branch Name')"
                    type="text"
                    readonly
                  />
                </b-col>
                <b-col md="4">
                  <InputField
                    id="staff-id"
                    v-model="newAccountOfficer.staffID"
                    :label="$t('Staff ID')"
                    type="text"
                    readonly
                  />
                </b-col>
                <b-col md="4">
                  <InputField
                    id="gender"
                    v-model="newAccountOfficer.gender"
                    :label="$t('Gender')"
                    type="text"
                    readonly
                  />
                </b-col>
                <b-col md="4">
                  <InputField
                    id="phone-number"
                    v-model="newAccountOfficer.phoneNumber"
                    :label="$t('Phone Number')"
                    type="text"
                    readonly
                  />
                </b-col>
                <b-col md="4">
                  <InputField
                    id="supervisor"
                    v-model="newAccountOfficer.supervisor"
                    :label="$t('Supervisor')"
                    type="text"
                    readonly
                  />
                </b-col>
                <b-col md="4">
                  <InputField
                    id="status"
                    v-model="newAccountOfficer.status"
                    :label="$t('Status')"
                    type="text"
                    readonly
                  />
                </b-col>
                <b-col md="4">
                  <TextAreaField
                    id="address"
                    v-model="newAccountOfficer.address"
                    rows="2"
                    :placeholder="$t('Address')"
                    :label="$t('Address')"
                    type="text"
                    readonly
                  />
                </b-col>

              </b-row>
            </app-collapse-item>
          </app-collapse>
          <b-row>
            <b-col md="12">
              <TextAreaField
                id="reason"
                v-model="newAccountOfficer.reason"
                rows="2"
                :placeholder="$t('Reason')"
                :label="$t('Reason')"
                type="text"
              />
            </b-col>
          </b-row>
        </div>

        <div
          v-if="isOldStaff && isNewStaff"
          class="text-center mt-5"
        >
          <Button
            :label="$t('Reassign')"
            :loading="isLoading"
            :disabled="isDisabled"
            size="lg"
            @click="handleSubmit"
          />
        </div>

      </b-col>
    </b-row>

    <FullScreenSpinner :show="showSpinner" />
  </b-card>
</template>

<script>

import {
  BCard, BRow, BCol, BForm,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { heightFade } from '@core/directives/animations'
import { required, positive } from '@validations'
import { ValidationObserver } from 'vee-validate'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { tableMixins } from '@core/mixins/table'
import { mapActions } from 'vuex'
import { modalMixins } from '@core/mixins/modal'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import InputField from '../../../forms/InputField.vue'
import SelectField from '../../../forms/SelectField.vue'
import TextAreaField from '../../../forms/TextAreaField.vue'
import Button from '../../../components/button/Button.vue'
import { accountPermissions } from '../../../../helpers/permissions'

export default {
  components: {
    BRow,
    BCol,
    BForm,
    InputField,
    SelectField,
    TextAreaField,
    Button,
    BCard,
    FullScreenSpinner,
    ValidationObserver,
    AppCollapse,
    AppCollapseItem,
  },
  directives: {
    Ripple,
    'height-fade': heightFade,
  },
  mixins: [sweetAlert, tableMixins, modalMixins],
  data() {
    return {
      isNewStaff: false,
      isOldStaff: false,
      isInvalidCustomer: false,
      isLoading: false,
      isDisabled: false,
      required,
      positive,
      showSpinner: false,
      oldStaffSearchParams: {
        oldStaffID: null,
      },
      newStaffSearchParams: {
        newStaffID: null,
      },
      oldAccountOfficer: {
        address: '',
        branchName: '',
        gender: '',
        name: '',
        phoneNumber: '',
        staffID: '',
        status: '',
        supervisor: '',
      },
      newAccountOfficer: {
        address: '',
        branchName: '',
        gender: '',
        name: '',
        phoneNumber: '',
        staffID: '',
        status: '',
        supervisor: '',
        reason: '',
      },
      accountOfficerOptions: [],
    }
  },
  mounted() {
    this.fetchAccountOfficers()
  },
  methods: {
    ...mapActions({
      getAccountOfficers: 'account/getAccountOfficerList',
      searchAccountOfficerInformation: 'account/searchAccountOfficerInformation',
      performAccountOfficerReassign: 'account/performAccountOfficerReassign',
    }),
    async handleOldStaffIDSearch() {
      this.$refs.oldAccountOfficerRules.validate().then(async success => {
        if (success) {
          try {
            this.showSpinner = true
            const { oldStaffID } = this.oldStaffSearchParams
            const staffID = oldStaffID
            const response = await this.searchAccountOfficerInformation({ staffID, permission: accountPermissions.ACCOUNT_OFFICER_REASSIGNMENT })
            const { status, data } = response
            if (status === 200 && data.data) {
              data.data.forEach(items => {
                this.oldAccountOfficer = items
              })
              this.isOldStaff = true
            }
            this.showSpinner = true
          } catch (error) {
            this.handleError(error)
          } finally {
            this.showSpinner = false
          }
        }
      })
    },
    async handleNewStaffIDSearch() {
      this.$refs.newAccountOfficerRules.validate().then(async success => {
        if (success) {
          try {
            this.showSpinner = true
            const { newStaffID } = this.newStaffSearchParams
            const staffID = newStaffID
            const response = await this.searchAccountOfficerInformation({ staffID, permission: accountPermissions.ACCOUNT_OFFICER_REASSIGNMENT })
            const { status, data } = response
            if (status === 200 && data.data) {
              data.data.forEach(items => {
                this.newAccountOfficer = items
              })
              this.isNewStaff = true
            }
            this.showSpinner = true
          } catch (error) {
            this.handleError(error)
          } finally {
            this.showSpinner = false
          }
        }
      })
    },
    async handleSubmit() {
      const text1 = this.$t('You are about to Reassign  Old Staff ID')
      const text2 = this.$t('with a New Staff ID')
      const text3 = this.$t('Are you sure you want to proceed?')

      this.confirm(this.reassignAccountOfficer, { text: (`${this.$t(text1)} ${this.oldAccountOfficer.staffID} ${this.$t(text2)} ${this.newAccountOfficer.staffID}. ${this.$t(text3)}`) })
    },
    async reassignAccountOfficer() {
      try {
        this.isLoading = true
        this.isDisabled = true
        const formData = {
          oldStaffID: this.oldAccountOfficer.staffID,
          oldStaffName: this.oldAccountOfficer.name,
          newStaffID: this.newAccountOfficer.staffID,
          newStaffName: this.newAccountOfficer.name,
          reason: this.newAccountOfficer.reason,
        }
        const response = await this.performAccountOfficerReassign({ formData, permission: accountPermissions.ACCOUNT_OFFICER_REASSIGNMENT })

        const { status } = response
        if (status === 200) {
          this.isOldStaff = false
          this.isNewStaff = false
          this.isLoading = false
          this.isDisabled = false
          this.resetInputField()
          this.alertSuccess({ text: this.$t('Your Account Officer Reassignemnt request was successful') })
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.isLoading = false
        this.isDisabled = false
        this.isOldStaff = false
        this.isInvalidCustomer = false
      }
    },
    async fetchAccountOfficers() {
      try {
        const { data, status } = await this.getAccountOfficers({
          search: '',
          page: 0,
          limit: 0,
          permission: accountPermissions.ACCOUNT_OFFICER_REASSIGNMENT,
        })

        if (status === 200 && data.data) {
          this.accountOfficerOptions = data.data.map(item => ({ label: `${item.name} - ${item.staffID}`, value: item.staffID }))
        }
      } catch (error) {
        this.alertError({ text: error })
      }
    },
    resetInputField() {
      this.oldStaffSearchParams = { ...null }
      this.newStaffSearchParams = { ...null }
      this.validCustomerData = { ...null }
      this.invalidCustomerData = { ...null }
      this.isOldStaff = false
      this.isNewStaff = false
    },
  },
}
</script>
<style scoped>
 [dir] .demo-inline-spacing > *, .custom-control , .custom-control-inline, .custom-checkbox {
    margin-top: 0rem !important;
}
.card-item {
  border: 1px solid #d8d6de !important;
  border-radius: 0.358rem
}
</style>
